var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"800px","height":"800px","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"Arrow / Arrow_Right_SM"}},[_c('path',{attrs:{"id":"Vector","d":"M7 12H17M17 12L13 8M17 12L13 16","stroke":"#FFFFFF","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }